import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import { contactAdminTomazz } from 'utils/contactAdminTomazz'
import { useLocation } from 'react-router-dom'

const WhatsappButton = () => {
  const location = useLocation()

  if (location.pathname === '/support') return null

  return (
    <button
      onClick={() =>
        contactAdminTomazz(
          `Halo TOMAZZ! 👋 Saya tertarik untuk mengetahui lebih lanjut tentang platform jual beli bisnis di TOMAZZ. Boleh dibantu ya? 😊`
        )
      }
      className="hover:bg-green-600 fixed bottom-6 right-6 z-[180] flex items-center gap-2 rounded-full border-none bg-success-bright px-4 py-2 text-white shadow-lg transition-all">
      <FaWhatsapp className="text-xl" />
      <span className="font-medium">Contact Us</span>
    </button>
  )
}

export default WhatsappButton
